import slugify from 'slugify';

function decodeChatChannel(cat = {}) {
  return {
    id: cat.id,
    name: cat.name,
    icon: cat.icon,
    slug: slugify(cat.name),
    disabled: !cat.active || cat.active === '0'
  };
}

export default decodeChatChannel;
